import React, { useEffect, useRef, useState } from 'react';
import { getApiUrl } from '../../utils/api';
import './connexion360.css';

// LOT 33 · GET /api/version au chargement puis toutes les 5 min : si la version change, « Nouvelle version de 360 » + « Recharger la page »
export const VersionBandeau = () => {
  const [nouvelle, setNouvelle] = useState(false);
  const premiere = useRef(null);
  useEffect(() => {
    const lire = () => fetch(`${getApiUrl()}/version`, { cache: 'no-store' }).then((r) => r.json()).then((d) => {
      if (!premiere.current) premiere.current = d.version; else if (d.version !== premiere.current) setNouvelle(true);
    }).catch(() => {});
    lire();
    const t = setInterval(lire, 5 * 60 * 1000);
    const vis = () => { if (document.visibilityState === 'visible') lire(); };
    document.addEventListener('visibilitychange', vis);
    return () => { clearInterval(t); document.removeEventListener('visibilitychange', vis); };
  }, []);
  if (!nouvelle) return null;
  return <div className="v360-bandeau" role="status" data-testid="version-bandeau"><span>Nouvelle version de 360</span><button type="button" onClick={() => window.location.reload()} data-testid="version-recharger">Recharger la page</button></div>;
};
